import { platforms } from "../../data/mock";
import { Smartphone, Tablet, Monitor } from "lucide-react";

const iconMap = {
  Smartphone: Smartphone,
  Tablet: Tablet,
  Monitor: Monitor
};

export const PlatformsSection = () => {
  return (
    <section id="platforms" className="relative py-28 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-900 to-brand-950" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-light/5 rounded-full blur-3xl" />

      {/* Subtle dots */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: 'radial-gradient(circle, #00CCFF 1px, transparent 1px)',
        backgroundSize: '48px 48px'
      }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-5 py-2 rounded-full bg-brand-light/10 border border-brand-light/15 text-brand-light text-xs font-bold uppercase tracking-widest mb-5 brand-heading">
            Multiplataforma
          </span>
          <h2 className="brand-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5">
            Donde Tú Estés
          </h2>
          <p className="text-brand-200/40 text-lg max-w-2xl mx-auto">
            Siempre a la mano de tu congregación, conectados incluso en medio de los obstáculos del mundo actual.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {platforms.map((platform, index) => {
            const Icon = iconMap[platform.icon];
            return (
              <div
                key={index}
                className="group text-center p-10 rounded-3xl bg-white/[0.04] backdrop-blur-sm border border-brand-light/8 hover:border-brand-light/30 transition-all duration-500 hover:bg-white/[0.07]"
              >
                <div className="w-20 h-20 mx-auto mb-6 rounded-3xl bg-brand-light/10 flex items-center justify-center group-hover:bg-brand-light/20 transition-all duration-300 group-hover:scale-110">
                  <Icon className="w-10 h-10 text-brand-light" />
                </div>
                <h3 className="brand-heading text-xl font-bold text-white mb-3">
                  {platform.title}
                </h3>
                <p className="text-white/45 text-sm leading-relaxed">
                  {platform.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
